/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Typography,
  Autocomplete as Selectbox,
} from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import swal from "sweetalert";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import GeofencingService from "src/service/geofencing";
import PolygonGeofenceMap from "src/components/mapFencing/PolygonGeofenceMap";
import { Autocomplete } from "@react-google-maps/api";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Update GeoFencing",
  },
];

const validationSchema = yup.object({
  geo_fence_name: yup
    .string("Enter Geofence name")
    .required("Geofence name is Required"),
});

const UpdateGeofencing = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const param = useParams();

  // State to store geofence data and loading state
  const [geofenceData, setGeofenceData] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  const getGeofenceData = (data) => {
    setGeofenceData(JSON.stringify(data));
  };

  const [startingPlace, setStartingPlace] = useState({
    name: "",
    latitude: "",
    longitude: "",
  });

  const [startingPlaceMarker, setStartingPlaceMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  const [endMarker, setEndMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  const onAutocompleteLoadStart = (autocomplete) => {
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setStartingPlace((prevStartingPlace) => ({
          ...prevStartingPlace,
          place_name: place.formatted_address,
          latitude: lat,
          longitude: lng,
        }));

        setStartingPlaceMarker({
          position: { lat, lng },
          address: place.formatted_address,
        });
      }
    });
  };

  const calculateEndingCoordinates = (startLat, startLng, distance) => {
    const endingLat = startLat + distance / 111.32;
    const endingLng = startLng;

    return { lat: endingLat, lng: endingLng };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const geofencingData = await GeofencingService.getGeofencingList({
          id: param.id,
        });

        setStartingPlace({
          geo_fence_name: geofencingData.data[0].geo_fence_name,
        });

        setGeofenceData(geofencingData.data[0].coordinates);
        setIsLoading(false); // Mark data as loaded
      } catch (error) {
        console.error("Error fetching geofencing data:", error);
        setIsLoading(false); // Even on error, set loading to false
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    id: param.id,
    geo_fence_name: startingPlace.geo_fence_name,
    coordinates: "",
    d_by: sessionData.data.id,
  };

  const { values, touched, errors, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        try {
          const final_data = {
            id: param.id,
            geo_fence_name: values.geo_fence_name,
            coordinates: geofenceData,
            d_by: sessionData.data.id,
          };

          const res = await GeofencingService.UpdateGeofencing(final_data);

          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/geofencing");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  const handleValuesChange = () => {
    if (startingPlace.latitude && startingPlace.longitude && values.radius) {
      const endingCoordinates = calculateEndingCoordinates(
        parseFloat(startingPlace.latitude),
        parseFloat(startingPlace.longitude),
        parseFloat(values.radius)
      );
      setEndMarker({
        position: endingCoordinates,
        address: `Geofencing Area (Radius: ${values.radius} km)`,
      });
    }
  };

  useEffect(() => {
    handleValuesChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startingPlace.latitude, startingPlace.longitude, values.radius]);

  // If data is still loading, show a loader or placeholder
  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <>
      <Breadcrumb title="Geo Fencing" items={BCrumb} />
      <ParentCard title="" style={{ minHeight: "600px !important" }}>
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update GeoFencing
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/geofencing");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid item spacing={3} container lg={12} md={12} sm={12} xs={12}>
                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="geo_fence_name">
                    Geo fence Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="geo_fence_name"
                    name="geo_fence_name"
                    type="text"
                    value={values.geo_fence_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.geo_fence_name && Boolean(errors.geo_fence_name)
                    }
                    helperText={touched.geo_fence_name && errors.geo_fence_name}
                    placeholder="Enter geo fence name"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="end_pt_latitude">
                    Place Name
                  </CustomFormLabel>

                  {/* Autocomplete Component */}
                  <Autocomplete onLoad={onAutocompleteLoadStart}>
                    <CustomTextField
                      type="text"
                      name="place_name"
                      value={startingPlace.place_name}
                      onChange={(event) => {
                        const newPlaceName = event.target.value;
                        setStartingPlace((prevState) => ({
                          ...prevState,
                          place_name: newPlaceName,
                        }));
                      }}
                      onBlur={handleBlur}
                      variant="outlined"
                      placeholder="Enter starting address"
                      fullWidth
                    />
                  </Autocomplete>
                </Grid>
              </Grid>
              {/* Display geofenceData when it's available */}
              {/* {geofenceData && console.log("geofenceData", geofenceData)} */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <PolygonGeofenceMap
                  center={startingPlaceMarker.position}
                  radius={values.radius}
                  markerPosition={startingPlaceMarker.position}
                  SendGeofenceData={geofenceData}
                  geofenceData={getGeofenceData}
                />
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12}>
              <Button type="submit" color="success" variant="contained">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default UpdateGeofencing;
